module.exports = __webpack_public_path__ + "img/download.692a9d0d.png";